
import React from 'react';
// Resources
import GoLogo from '../../image/gogochart_alt_white_logo.png';

export default class HeaderLogo extends React.Component {
    render() {
        return (
            <div className="logo-container">
                {
                    this.props.isClickable && (
                        <img src={process.env.PUBLIC_URL + GoLogo} onClick={ () => this.props.history.push(`${'/'}`) } />
                    ) || (
                        <img src={process.env.PUBLIC_URL + GoLogo} />
                    )
                }
            </div>
        );
    }
};


// WEBPACK FOOTER //
// ./src/components/Headers/Logo.js